import { TASK } from 'fixtures/api'
import { getAllList } from 'services/cmsService'

const getTaskListData = (type, filter = null) => {
  const setParams = () => filter ?
    Object.keys(filter)
      .filter(key => filter[key] && (filter[key] !== '' || filter[key] !== '-'))
      .map(key => key + '=' + filter[key]).join('&')
    : ''

  return async dispatch => {
    let data = []
    let newData = await getAllList(`${TASK[type]()}${filter ? `?${setParams()}` : ''}`)
    if (newData) {
      data = newData
    }

    dispatch({
      type: `GET_${type}`,
      payload: data
    })
  }
}

const setTaskData = (type, id) => {
  return async dispatch => {
    let data = {}
    let newData = await getAllList(TASK[type](id))
    if (newData) {
      data = newData
    }

    dispatch({
      type: `SET_${type}`,
      payload: data
    })
  }
}

export { getTaskListData, setTaskData }
